import { Button, Form, FormInstance, Modal } from 'antd';
import { ScanOutlined } from '@ant-design/icons';
import { FieldProps, FieldType } from 'components/DataForm/DataForm';
import { useTranslation } from 'react-i18next';
import Scanner from 'components/Scanner/Scanner';

import find from 'lodash/find';
import includes from 'lodash/includes';

import '../styles.less';

interface ScannerModalProps {
  form?: FormInstance<any>;
  field?: FieldProps;
  local?: boolean;
  multiple?: boolean;
  searchCallBack?: (value: string) => any;
  // Normalizes the raw scanned text before it is written to the form / passed to
  // searchCallBack - e.g. extracting a bare barcode out of a scanned tool QR URL.
  transformValue?: (scanned: string) => string;
}

const ScannerModal = ({ form, field, searchCallBack, local, multiple, transformValue }: ScannerModalProps) => {
  const { t } = useTranslation();

  if (!form || !field) return null;

  const handler = (scanned: string) => {
    const value = transformValue ? transformValue(scanned) : scanned;
    scannerSetFields(field, value);
    Modal.destroyAll();
  };

  const scannerSetFields = async (field: FieldProps, value: string) => {
    switch (field.type) {
      case FieldType.SELECT_SEARCH: {
        if (!searchCallBack) return;

        const data = local ? searchCallBack(value) : await searchCallBack(value).unwrap();
        const result = find(data, (val: any) => includes(Object.values(val), value));

        if (!multiple) form.resetFields([ field.name ]);
        if (result) {
          if (multiple) {
            const currentValues = form.getFieldValue(field.name) || [];
            if (!currentValues.includes(result.value)) {
              form.setFieldValue(field.name, [ ...currentValues, result.value ]);
            }
          } else {
            form.setFieldValue(field.name, result.value);
          }
        }
        else {
          form.setFields([ { name: field.name, errors: [ t('common.notfound') ] } ]);
        }
        break;
      }
      default: {
        form.setFields([ { name: field.name, value: value, touched: true } ]);
        form.validateFields([ field.name ]);
        break;
      }
    }
  };

  const info = () => {
    Modal.info({
      content: (
        <Scanner callback={handler} />
      ),
      icon: false,
      okText: t('common.close'),
      className: 'scanner-modal'
    });
  };

  return <Form.Item label={<>&nbsp;</>}>
    <Button style={{ width: '100%' }} onClick={info} icon={<ScanOutlined />} />
  </Form.Item>;
};

export default ScannerModal;